// Status
export const GET_BLOCKED_STATUS_REQUEST = "GET_BLOCKED_STATUS_REQUEST";
export const GET_BLOCKED_STATUS_SUCCESS = "GET_BLOCKED_STATUS_SUCCESS";
export const GET_BLOCKED_STATUS_FAIL = "GET_BLOCKED_STATUS_FAIL";
